import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import TableStatusFilterComponent from '../../../shared/components/form/TableFilterComponent';
import TableSearchableFilterComponent from '../../../shared/components/form/TableSearchableFilterComponent';
import * as Constants from '../../../constants/constants';
import { SortingField } from '../../common/SortingCell';
import { Link } from 'react-router-dom';

export default class TableComponent extends Component {
  static propTypes = {
    heads: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        name: PropTypes.string,
        sortable: PropTypes.bool,
        filterable: PropTypes.bool,
      }),
    ).isRequired,
    rows: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  handleStatusFilter = (list, key) => {
    this.props.handleGridFilter(key, list);
  };

  goTo = (e, url) => {
    e.preventDefault();
    this.props.history.push(url);
  };

  render() {
    const { rows, heads, sortField, sortOrder } = this.props;
    const headText = heads.map((head) => head.key);
    const classByKey = heads.reduce((acc, head) => {
      if (head.className) {
        acc[head.key] = head.className;
      }
      return acc;
    }, {});
    const capitalizedText = heads.filter((head) => {
      if (head.capitalize) {
        return head.key;
      }
      return false;
    });

    const hyperLinkOrValue = (
      row,
      value,
      key,
      capitalizeClass,
      valuesWithHyperLinks,
    ) => {
      const colClass = classByKey[value] || '';
      if (valuesWithHyperLinks.includes(value)) {
        const path = `/client-list/profile/${row.parentId}`;

        return (
          <td
            key={key}
            title={row[value]}
            className={`custom-no-over-flow-td ${colClass} ${capitalizeClass}`}
          >
            {value === Constants.CLIENT_TABLE_FIELDS.parentName && (
              <Link to={`${path}?tab=${Constants.QUERY_TAB_PARAMS.parent}`}>
                {row[value]}
              </Link>
            )}
            {value === Constants.CLIENT_TABLE_FIELDS.petName && (
              <Link
                to={`${path}?tab=${Constants.QUERY_TAB_PARAMS.petInfo}&${Constants.QUERY_PARAMS.pet}=${row.petId}`}
              >
                {row[value]}
              </Link>
            )}
          </td>
        );
      }

      return (
        <td
          key={key}
          title={row[value]}
          className={`custom-no-over-flow-td ${colClass} ${capitalizeClass}`}
        >
          {row[value]}
        </td>
      );
    };

    const tableRows = rows.map((row, key) => {
      const _row = Object.keys(row).map((value, key) => {
        if (headText.includes(value)) {
          const capitalizeClass = capitalizedText.includes(value)
            ? 'text-capitalize'
            : '';
          return hyperLinkOrValue(row, value, key, capitalizeClass, [
            Constants.CLIENT_TABLE_FIELDS.petName,
            Constants.CLIENT_TABLE_FIELDS.parentName,
          ]);
        }
        return true;
      });

      return (
        <tr className="body-tr" key={key}>
          {_row}
          {!this.props.noActions && (
            <td>
              <UncontrolledDropdown>
                <DropdownToggle>
                  <span className="six-layers" />
                </DropdownToggle>
                <DropdownMenu className="dropdown__menu">
                  <DropdownItem tag="div">
                    <a onClick={() => this.props.viewProfile(row)}>
                      View Profile
                    </a>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </td>
          )}
        </tr>
      );
    });

    const sortFieldComponent = (head, icon, thisSortField) => (
      <SortingField
        name={head.name}
        icon={icon}
        onSort={() => this.props.handleGridSort(thisSortField)}
      />
    );

    const headers = heads.map((head, key) => {
      const thisSortField = head.key;
      const thClass = head.className ?? '';

      if (head.sortable && !head.filterable) {
        return (
          <th key={key} className={thClass}>
            {sortField === head.key
              ? sortOrder === 1
                ? sortFieldComponent(head, 'triangle-up', thisSortField)
                : sortFieldComponent(head, 'triangle-down', thisSortField)
              : sortFieldComponent(head, 'diamond-narrow', thisSortField)}
          </th>
        );
      }

      if (head.filterable) {
        return (
          <th key={key} className={thClass}>
            {head.key === 'breedName' ? (
              <TableSearchableFilterComponent
                allFilters={head.filterValue || []}
                action={(list) => this.handleStatusFilter(list, head.key)}
                onSearch={(search) =>
                  this.props.handleFilterSearch(head.key, search)
                }
                label={head.name}
                showSelectedOption
              />
            ) : (
              <TableStatusFilterComponent
                allFilters={head.filterValue || []}
                action={(list) => this.handleStatusFilter(list, head.key)}
                label={head.name}
              />
            )}
          </th>
        );
      }

      return (
        <th key={key} className={thClass}>
          <p>{head.name}</p>
        </th>
      );
    });

    return (
      <div className="row">
        <div className="col-md-12">
          <Table striped className="custom-table loyal-table fixed-layout">
            <thead>
              <tr className="header-tr">
                {headers}
                {!this.props.noActions && (
                  <th className="text-center action">
                    <p className=" action">Action</p>
                  </th>
                )}
              </tr>
            </thead>
            <tbody>{tableRows}</tbody>
          </Table>
          {rows.length === 0 && (
            <div className="no-data-message">No results found</div>
          )}
        </div>
      </div>
    );
  }
}
